import React, {FC, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

export interface TModulePageAnalytics {
    views_today: string
    views_7: string
    views_30: string
    visitors_today: string
    visitors_7: string
    visitors_30: string
}

const ModulePageAnalytics: FC<{pageAnalytics: TModulePageAnalytics}> = ({pageAnalytics}) => {
    const [open, setOpen] = useState(false)

    return (
        <div
            className='page-analytics-fab'
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            <div className='fab-dot'>
                <KTSVG path={`/media/crm/icons/visible.svg`} />
            </div>

            {open && (
                <div className='page-analytics-popover'>
                    <div className='title'>Просмотры страницы</div>
                    <div className='row'>
                        <span>
                            Сегодня <b>{pageAnalytics.views_today}</b>
                        </span>
                    </div>
                    <div className='row'>
                        <span>
                            7 дней: <b>{pageAnalytics.views_7}</b>
                        </span>
                    </div>
                    <div className='row'>
                        <span>
                            30 дней: <b>{pageAnalytics.views_30}</b>
                        </span>
                    </div>

                    <div className='separator' />

                    <div className='title'>Посетители</div>
                    <div className='row'>
                        <span>
                            Сегодня <b>{pageAnalytics.visitors_today}</b>
                        </span>
                    </div>
                    <div className='row'>
                        <span>
                            7 дней: <b>{pageAnalytics.visitors_7}</b>
                        </span>
                    </div>
                    <div className='row'>
                        <span>
                            30 дней: <b>{pageAnalytics.visitors_30}</b>
                        </span>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ModulePageAnalytics
